import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { AuthService } from 'src/shared/services/REST-API/rest.service';
import { ActivatedRoute } from '@angular/router';
import { take } from 'rxjs/operators';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-clan-screen',
  templateUrl: './clan-screen.component.html',
  styleUrls: ['./clan-screen.component.css']
})
export class ClanScreenComponent implements OnInit {
  clanDetails: any;
  acvtiveTab = 'clanMembers';
  fileToUpload: File;
  avatar;
  constructor(private authApi: AuthService,
    private router: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    this.spinner.show();
    this.router.queryParams.pipe(
      take(1)
    ).subscribe((data) => {
      this.authApi.getClanDetails(data.clan_id).subscribe((details) => {
        if (!details) { return }
        this.clanDetails = details;
        this.spinner.hide();
      })
    })
    this.getClanAvatar()
  }

  clanRequest(user_id, isAccecpted) {
    const reqBody = {
      user_id,
      isAccecpted
    }
    this.authApi.updateOnNewClanJoinRequest(this.clanDetails._id, reqBody).subscribe((details) => {
      this.ngOnInit();
    })

  }

  onClickTab(tabName) {
    this.acvtiveTab = tabName;
  }


  uploadAvatar(files: FileList) {
    this.fileToUpload = files.item(0);
    const formData: FormData = new FormData();
    formData.append('name', this.fileToUpload, this.fileToUpload.name);
    this.authApi.setClanAvatar(formData).subscribe((data) => {
      this.getClanAvatar()
    })
  }
  getClanAvatar() {
    this.authApi.getClanAvatar().subscribe((data) => {
      if (JSON.stringify(data) === '{}') { return }
      var uints = new Uint8Array(data.binary.data);
      var image = btoa(String.fromCharCode.apply(null, uints));
      this.avatar = this.sanitizer.bypassSecurityTrustUrl('data:image/jpg;base64,' + image);
    })
  }

}
